export default "https://cdn-static.gokick.com/assets/6a734ef49f9399dbf744c5b441c6b52a80c19f9a/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";